<template>
  <div class="m-gov-wrapper">
    <div class="gov-thirdWrapper">
      <div class="gov-thirdTitle">
        <WaveTitle title="投资者服务" subhead="Investor service" isMobile />
      </div>
      <div class="gov-thirdContent">
        <div class="text">
          <div class="text-row1">联系我们</div>
          <div class="text-row2">投资者互动平台</div>
          <div class="text-row3">
            <a href="https://ir.p5w.net/c/920799.shtml" target="_blank">
              <span>立即跳转</span>
              <div class="triangle"></div>
            </a>
          </div>
        </div>
        <div class="box">
          <div class="box-item">
            <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/phone/gov_icon_phone.svg" alt="" />
            <div>投资者热线</div>
            <div>021-68816718</div>
          </div>
          <div class="box-item">
            <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/phone/gov_icon_email.svg" alt="" />
            <div>投资者邮箱</div>
            <div>public@i2finance.net</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WaveTitle from "@/components/WaveTitle.vue";
  export default {
    name: "GovernmentComp",
    components: { WaveTitle },
    props: {},
    data() {
      return {
        // 年报
        annualList: [],
        // 中报
        InterimList: [],
        // 季报
        QuarterlyList: [],
        shareholderList: [],
      };
    },
    filters: {},
    created() {
      this.getachievent();
    },
    mounted() {
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      // 获取业绩表
      getachievent() {
        // 股东权益
        this.$axios.get("/parameter/shareholderList").then((res) => {
          this.shareholderList = res.data.data;
          console.log("年报业报", this.shareholderList);
        });
      },

      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .m-gov-wrapper {
    .gov-thirdWrapper {
      .gov-thirdTitle {
        margin-top: 44px;
      }
      .gov-thirdContent {
        min-height: 500px;
        padding: 44px 24px;
        background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/relations/phone/gov_thirdback.png");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        .text {
          margin-bottom: 58px;
          font-weight: normal;
          line-height: normal;
          letter-spacing: 0em;
          color: #001f34;
          display: flex;
          text-align: left;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          white-space: pre-wrap;

          .text-row1 {
            font-size: 24px;
            margin-bottom: 14px;
          }
          .text-row1 {
            font-size: 26px;
            font-weight: 500;
            letter-spacing: 0.06em;
            margin-bottom: 4px;
          }
          .text-row3 {
            font-size: 20px;
            margin-bottom: 12px;
          }
          .text-row2 {
            font-size: 14px;
            margin-bottom: 4px;
            a {
              color: #727272;
            }
          }
          .text-row3 {
            a {
              display: flex;
              flex-direction: row;
              align-items: center;
              column-gap: 4px;
              font-size: 12px;
              color: #727272;
              .triangle {
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 8px solid #f49a42;
              }
            }
          }
        }
        .box {
          display: flex;
          flex-direction: row;
          .box-item {
            width: 136px;
            min-width: 136px;
            margin-right: 14px;
            padding: 14px 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            row-gap: 4px;
            border-radius: 8px;
            opacity: 0.8;
            background: #ffffff;
            box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.16);
            img {
              width: 24px;
              min-width: 24px;
              height: 24px;
              margin-bottom: 10px;
            }
            div {
              font-size: 14px;
              font-weight: normal;
              line-height: normal;
              letter-spacing: 0em;
              color: #001f34;
            }
            div:last-child {
              font-size: 12px;
              color: #727272;
            }
          }
        }
      }
    }
  }
</style>
